import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Activity, ChevronLeft, UserCheck } from "lucide-react";
import { ghostButtonClass, Status } from "../components/ui";
import { ActionCard } from "../pdday/ActionCard";
import { AssignedPDDayCard } from "../pdday/AssignedPDDayCard";
import { SessionControls } from "../pdday/SessionControls";
import { SessionStatusBar } from "../pdday/SessionStatusBar";
import { usePDDay } from "../pdday/usePDDay";
import { usePDDayNumber } from "../pddays/usePDDays";

export function PDDayDetail() {
  const { t } = useTranslation();
  const { sessionID = "" } = useParams();
  const { data, loading, error, reload } = usePDDay(sessionID);
  const dayNumber = usePDDayNumber(sessionID);

  const back = (
    <NavLink to="/pd-days" className={`${ghostButtonClass} mb-4`}>
      <ChevronLeft size={16} />
      {t("backToPDDays")}
    </NavLink>
  );

  if (loading) return <Status variant="loading" title={t("loading")} message={t("loadingPDDay")} />;
  if (error || !data) {
    return (
      <>
        {back}
        <Status
          variant="error"
          title={t("pdDayUnavailable")}
          message={error || t("noAssignedPDDayHelp")}
        />
      </>
    );
  }

  const { detail, stats, markedCount } = data;

  return (
    <div className="flex flex-col gap-5 pb-6">
      {back}
      <h1 className="text-xl font-semibold tracking-tight text-app-ink">
        {dayNumber ? t("pdDayDetailsOrdinal", { number: dayNumber }) : t("pdDayDetails")}
      </h1>
      <SessionStatusBar status={detail.status} />
      <AssignedPDDayCard detail={detail} dayNumber={dayNumber} />

      <section className="flex flex-col gap-3">
        <div className="flex items-center justify-between px-1">
          <h3 className="text-sm font-semibold text-app-ink">{t("facilitatorActions")}</h3>
          {/* <span className="text-xs text-app-muted">{t("tapCardToOpen")}</span> */}
        </div>
        <ActionCard
          to={`/attendance/${detail.id}`}
          icon={UserCheck}
          title={t("attendance")}
          description={t("attendanceHelp", { total: detail.teacher_count, marked: markedCount })}
          badge={t("markedBadge", {
            marked: markedCount,
            total: stats.roster_size || detail.teacher_count,
          })}
        />
        <ActionCard
          to={`/pd-day-progress/${detail.id}`}
          icon={Activity}
          title={t("pdDayProgress")}
          description={t("pdDayProgressHelp")}
        />
      </section>

      <SessionControls detail={detail} onChanged={reload} />
    </div>
  );
}
